import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { ConfigurationService } from '../../../../../Configuration/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class TransactionsWithDirectorsService {

  URl = this.ConfigService.getAPIBaseUrl() + 'api/TranscationsWithDirectorsDetails'
  constructor(private http: HttpClient, private ConfigService: ConfigurationService) { }

  insertgriddetails(id: any, data: any) {
    //const httpOptions = { headers: new HttpHeaders({ 'content-type': 'text/json' }) }
    return this.http.post(this.URl + '/Adding?id=' + id, data)
  }
  insertdetails(data: any) {
    //const httpOptions = { headers: new HttpHeaders({ 'content-type': 'text/json' }) }
    return this.http.post(this.URl + '/Addingpagedata', data)
  }
  getdata(APPeriodId: any) {
    return this.http.get(this.URl + '/Getdata?APPeriodId=' + APPeriodId)
  }
  getdata_LY(APPeriodId: any) {
    return this.http.get(this.URl + '/Getdata_LY?APPeriodId=' + APPeriodId)
  }
  getgriddata(APPeriodId: any) {
    return this.http.get(this.URl + '/Getgriddata?APPeriodId=' + APPeriodId)
  }
}
